<template>
  <div class="video-container" :class="{'-scroll': remoteStreams.length > 1}">
    <!-- 自分の画像(音はミュートする) -->
    <video @loadeddata="playVideo" id="local_video_share" class="off-video" muted playsinline autoplay></video>
    <video @loadeddata="playVideo" @click="bigVideo(-1)" id="local_video" class="video-size-remote" :class="{'big-video': bigIndex === -1, 'off-video': !isConnect}" muted playsinline autoplay></video>
    <video @loadeddata="playVideo" @click="bigVideo(i)" v-for="(stream, i) in remoteStreams" :key="i" :srcObject.prop="stream" class="video-size-remote" :class="{'big-video': bigIndex === i}" autoplay playsinline></video>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'OfficeVideo',
  componentName: 'OfficeVideo',
  props: ['isConnect', 'isShare'],
  computed: {
    ...mapState('webRTC', ['remoteStreams']),
  },
  data () {
    return {
      bigIndex: null,
    }
  },
  methods: {
    async playVideo (event) {
      await event.target.play()
    },
    bigVideo (index) {
      if (this.bigIndex === index) {
        this.bigIndex = null
      } else {
        this.bigIndex = index
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video-container {
  width: 100%;
  height: auto;
  overflow: auto;
  position: absolute;
  display: flex;
  justify-content: center;
  pointer-events: none;
  align-items: center;
}
.-scroll {
  pointer-events: auto;
  background: rgba(0,0,0,0.4);
}
.video-container::-webkit-scrollbar {
  width:  8px !important;
  height: 8px !important;
  visibility: visible !important;
}
.video-size-remote {
  width: auto;
  height: 240px;
  background: transparent;
  border-radius: 8px;
  pointer-events: auto;
  margin-top: 8px;
  margin-left: 8px;
}
.big-video {
  position: fixed;
  z-index: 40;
  top : 40px;
  left: 40px;
  width: calc(100% - 80px);
  height: calc(100% - 80px);
}
.off-video {
  border: none;
  pointer-events: none;
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/OfficeVideo.vue